// chat_link_preview_ready（リンクプレビューの非同期取得完了）を受けて、
// タイムライン中の該当メッセージの linkPreview を差し替えるハンドラを生成する共通関数。
// 全チャット(personal/group/event × admin/artist)の socket 購読で再利用する。
// messageId は UUID で全チャット横断で一意なので、id 一致のみで安全にパッチできる。
import { mergeMessageLinkPreview } from './linkPreviewCollection';

export const makeLinkPreviewReadyHandler = (setMessages) => (payload) => {
  if (typeof setMessages !== 'function') return;
  const messageId = String(payload?.messageId || payload?.message_id || '');
  const linkPreview = payload?.linkPreview;
  if (!messageId || !linkPreview) return;
  setMessages((prev) => {
    if (!Array.isArray(prev)) return prev;
    let changed = false;
    const next = prev.map((m) => {
      if (String(m?.id) !== messageId) return m;
      changed = true;
      return mergeMessageLinkPreview(m, linkPreview, payload?.previewIndex);
    });
    return changed ? next : prev;
  });
};
